import { ArticleParagraph3, IconButton, Image, Label, UIHeading2, UIText1, UIText2 } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import { WrapElementsSpacer } from '@/packages/shared-ui';
import { ScrollFade } from '@/packages/shared-ui/components/ScrollFade';
import { extractUndefined } from '@/packages/utils/extractUndefined';

import { type NativeTGBBannerProps } from '../../../types';
import { GoToButton } from '../GoToButton';
import { Metro } from '../Metro';

import styles from './NativeTGBBannerNarrow.css';

type NativeTGBBannerNarrowProps = NativeTGBBannerProps & {
  onClose: VoidFunction;
};

export const NativeTGBBannerNarrow: FC<NativeTGBBannerNarrowProps> = props => {
  const { metroIconType, params, onClose } = props;

  const {
    title,
    location,
    description,
    annotation,
    imageURL,
    image,
    metro,
    reference,
    site,
    url,
    metroDistance,
    metroColor,
    button,
    label,
  } = params;

  return (
    <div className={styles['container']} data-testid="adfox_native_aside_info">
      <a className={styles['main-link']} href={reference || url} rel="noreferrer" target="_blank">
        <Image objectFit="cover" src={imageURL || image || ''} />
        {!!label && (
          <div className={styles['fox-label-wrapper']}>
            <Label background="surface-warning-default" color="text-warning-default">
              {label}
            </Label>
          </div>
        )}
        <div className={styles['main-content']}>
          <div className={styles['title']}>
            <UIHeading2 as="h2" color="current_color">
              {title}
            </UIHeading2>
          </div>
          <div className={styles['description']}>
            <UIText1 fontWeight="bold">{description}</UIText1>
          </div>
          <div className={styles['address-wrapper']}>
            {!!metro && (
              <div className={styles['metro-wrapper']}>
                <Metro
                  metro={metro}
                  metroColor={extractUndefined(metroColor)}
                  metroDistance={extractUndefined(metroDistance)}
                  metroIconType={extractUndefined(metroIconType)}
                />
              </div>
            )}
            <UIText2 color="gray60_100">{location}</UIText2>
          </div>

          <div className={styles['links-wrapper']}>
            <WrapElementsSpacer horizontalSpace={12} verticalSpace={12}>
              <GoToButton buttonText={extractUndefined(button)} />
              {!!site && <UIText2 color="accent-main-primary">{site}</UIText2>}
            </WrapElementsSpacer>
          </div>

          {!!annotation && (
            <div className={styles['fox-info-wrapper']}>
              <ArticleParagraph3 color="gray40_100" fontWeight="bold">
                <span className={styles['fox-info']}>
                  {annotation}
                  <ScrollFade size={18} />
                </span>
              </ArticleParagraph3>
            </div>
          )}
        </div>
      </a>
      <div className={styles['close-button-wrapper']}>
        <IconButton aria-label="Закрыть" icon={<IconActionClose16 color="gray60_100" />} onClick={onClose} />
      </div>
    </div>
  );
};
